import { AmbassadorAdvantagesList, AmbassadorLearnMoreButton, AmbassadorMissionSteps } from './ambassador-shared';
import { useAmbassadorSignUpUrl } from './constants';
import { Trans, useTranslation } from 'react-i18next';
import { Linking, Pressable } from 'react-native';

import { BottomSheet } from 'app/design/primitives/bottom-sheet';
import { ScrollView } from 'react-native-gesture-handler';
import { Column, Row } from 'app/design/primitives/box';

import { Button } from 'app/design/primitives/button';
import { Text } from 'app/design/primitives/text';
import { AmbassadorMedalIcon } from 'app/design/icons/ambassador-medal-icon';
import { createTheme as createDSTheme } from 'app/shopify';
import { IconX } from '@tabler/icons-react-native';
import { ICON_STROKE_WIDTH } from 'app/utils/constants';
const theme = createDSTheme();

export const AmbassadorBottomSheet = function AmbassadorBottomSheet({
  open,
  onClose,
}: {
  open: boolean;
  onClose: () => void;
}) {
  const { t } = useTranslation('ambassador');
  const { t: tA11y } = useTranslation('accessibility');
  const url = useAmbassadorSignUpUrl();

  return (
    <BottomSheet
      gestureEnabled={false}
      onClose={onClose}
      open={open}
      showIndicator={false}
      CustomHeaderComponent={
        <Row
          alignItems="center"
          style={{
            backgroundColor: 'rgba(255,255,255,0.25)',
            borderBottomWidth: 1,
            borderBottomColor: 'rgba(0,0,0,0.06)',
          }}
        >
          <Pressable
            accessibilityLabel={tA11y('close')}
            accessibilityRole="button"
            hitSlop={10}
            onPress={onClose}
            style={{ padding: theme.spacing['spacing.general.x4'] }}
          >
            <IconX strokeWidth={ICON_STROKE_WIDTH} size={32} />
          </Pressable>
          <Text
            flex={1}
            fontWeight="700"
            variant="headerXSmall"
            textAlign="center"
            style={{ marginRight: 32 + theme.spacing['spacing.general.x4'] * 2 }}
          >
            {t('ctaButton')}
          </Text>
        </Row>
      }
    >
      <ScrollView>
        <Column
          gap="spacing.general.x8"
          paddingHorizontal="spacing.general.x4"
          paddingBottom="spacing.general.x12"
          style={{ paddingTop: theme.spacing['spacing.general.x2'] }}
        >
          <Row
            justifyContent="center"
            backgroundColor="text.brand"
            borderRadius="radius.lg"
            paddingVertical="spacing.general.x10"
          >
            <AmbassadorMedalIcon width={140} height={140} color={theme.colors['surface.tertiary']} />
          </Row>

          <Text variant="bodyBase">
            <Trans
              components={{ strong: <Text fontWeight="700" /> }}
              i18nKey="description.notYetAmbassador"
              ns="ambassador"
            />
          </Text>

          <Button onPress={() => void Linking.openURL(url)} style={{ borderRadius: 999 }} variant="primary">
            <Text color="text.inverse.primary" fontWeight="700" textAlign="center" variant="bodyBase">
              {t('ctaButton')} ↗
            </Text>
          </Button>

          <Column gap="spacing.general.x2">
            <Text fontWeight="700" variant="bodyLarge">
              {t('advantages.titleNotYet')}
            </Text>
            <AmbassadorAdvantagesList listGap="spacing.general.x1" rowGap="spacing.general.x4" />
          </Column>

          <Column gap="spacing.general.x2">
            <Text fontWeight="700" variant="bodyLarge">
              {t('mission.title')}
            </Text>
            <Text variant="bodyBase">
              <Trans components={{ strong: <Text fontWeight="700" /> }} i18nKey="mission.description" ns="ambassador" />
            </Text>
            <Column
              gap="spacing.general.x4"
              marginTop="spacing.general.x2"
              backgroundColor="surface.tertiary-neutral"
              padding="spacing.general.x2"
              borderRadius="radius.lg"
            >
              <AmbassadorMissionSteps textVariant="bodyBase" />
            </Column>
            <AmbassadorLearnMoreButton paddingLeft={0} />
          </Column>
        </Column>
      </ScrollView>
    </BottomSheet>
  );
};
